import React from 'react';
import Typography from '@mui/material/Typography';

type LabelWithAsteriskProps = {
  text: string;
};

export const LabelWithAsterisk: React.FC<LabelWithAsteriskProps> = (props) => {
  return (
    <Typography variant="body1">
      {props.text}
      <Typography component="span">*</Typography>
    </Typography>
  );
};
